<template>
  <div class="module-info">
    <div class="data-info-left">
      <div class="info-image">
        <img :src="info.bikeTypeImagePath" alt="" />
      </div>
      <div class="qr-code">
        <img :src="qrCode" alt="" />
        <DiluButton
          type="custom"
          @click="exportQrcode"
          :title="$t('pages.equipment.text70')"
        ></DiluButton>
      </div>
      <div class="info-list">
        <div class="info-list-title">
          <span>{{ info.bikeTypeName }}</span>
          <label>{{ info.bikeCategoryName }}</label>
        </div>
        <div class="describe">{{ info.systemVersion }}</div>
      </div>
      <el-divider></el-divider>
      <div class="data-ul">
        <el-descriptions size="mini" :column="2" border>
          <el-descriptions-item
            :label="$t('pages.equipment.text7')"
            v-if="info.bikeCode"
            >{{ info.bikeCode }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('omission.text3')"
            v-if="info.deviceCode"
            >{{ info.deviceCode }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text74')"
            v-if="info.batteryCommunicationId"
            >{{ info.batteryCommunicationId }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text75')"
            v-if="info.batteryFwVersion"
            >{{ info.batteryFwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text76')"
            v-if="info.batteryHwVersion"
            >{{ info.batteryHwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text85')"
            v-if="info.batterySn"
            >{{ info.batterySn }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text77')"
            v-if="info.batteryKey"
            >{{ info.batteryKey }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text78')"
            v-if="info.batteryLockCommunicationId"
            >{{ info.batteryLockCommunicationId }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text79')"
            v-if="info.batteryLockFwVersion"
            >{{ info.batteryLockFwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text80')"
            v-if="info.batteryLockHwVersion"
            >{{ info.batteryLockHwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text81')"
            v-if="info.batteryLockKey"
            >{{ info.batteryLockKey }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text82')"
            v-if="info.batteryLockMacAddress"
            >{{ info.batteryLockMacAddress }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text83')"
            v-if="info.batteryLockSn"
            >{{ info.batteryLockSn }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text86')"
            v-if="info.bikeFrameSn"
            >{{ info.bikeFrameSn }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text87')"
            v-if="info.bleFwVersion"
            >{{ info.bleFwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text88')"
            v-if="info.bleHwVersion"
            >{{ info.bleHwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text89')"
            v-if="info.bleKey"
            >{{ info.bleKey }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text90')"
            v-if="info.bleMacAddress"
            >{{ info.bleMacAddress }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text91')"
            v-if="info.bleName"
            >{{ info.bleName }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text92')"
            v-if="info.bleSn"
            >{{ info.bleSn }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text93')"
            v-if="info.ccuBleKey"
            >{{ info.ccuBleKey }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text94')"
            v-if="info.ccuBleMacAddress"
            >{{ info.ccuBleMacAddress }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text95')"
            v-if="info.ccuBleName"
            >{{ info.ccuBleName }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text96')"
            v-if="info.ccuCommunicationId"
            >{{ info.ccuCommunicationId }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text97')"
            v-if="info.ccuFwVersion"
            >{{ info.ccuFwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text98')"
            v-if="info.ccuHwVersion"
            >{{ info.ccuHwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text99')"
            v-if="info.ccuSn"
            >{{ info.ccuSn }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text100')"
            v-if="info.chainLockCommunicationId"
            >{{ info.chainLockCommunicationId }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text101')"
            v-if="info.chainLockFwVersion"
            >{{ info.chainLockFwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text102')"
            v-if="info.chainLockHwVersion"
            >{{ info.chainLockHwVersion }}</el-descriptions-item
          >
          <el-descriptions-item label="ICCID" v-if="info.iccid">{{
            info.iccid
          }}</el-descriptions-item>
          <el-descriptions-item
            :label="$t('pages.equipment.text103')"
            v-if="info.chainLockKey"
            >{{ info.chainLockKey }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text104')"
            v-if="info.chainLockMacAddress"
            >{{ info.chainLockMacAddress }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text105')"
            v-if="info.chainLockSn"
            >{{ info.chainLockSn }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text106')"
            v-if="info.ecuCommunicationId"
            >{{ info.ecuCommunicationId }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text107')"
            v-if="info.ecuFwVersion"
            >{{ info.ecuFwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text108')"
            v-if="info.ecuHwVersion"
            >{{ info.ecuHwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text109')"
            v-if="info.ecuKey"
            >{{ info.ecuKey }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text110')"
            v-if="info.ecuSn"
            >{{ info.ecuSn }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text112')"
            v-if="info.hubLockCommunicationId"
            >{{ info.hubLockCommunicationId }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text113')"
            v-if="info.hubLockFwVersion"
            >{{ info.hubLockFwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text114')"
            v-if="info.hubLockHwVersion"
            >{{ info.hubLockHwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text115')"
            v-if="info.hubLockKey"
            >{{ info.hubLockKey }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text116')"
            v-if="info.hubLockMacAddress"
            >{{ info.hubLockMacAddress }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text117')"
            v-if="info.hubLockSn"
            >{{ info.hubLockSn }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text313')"
            v-if="info.fingerLockFwVersion"
            >{{ info.fingerLockFwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text314')"
            v-if="info.fingerLockHwVersion"
            >{{ info.fingerLockHwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text315')"
            v-if="info.fingerLockKey"
            >{{ info.fingerLockKey }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text316')"
            v-if="info.fingerLockMacAddress"
          >
            <el-button @click="fingerMacEdit">{{
              info.fingerLockMacAddress
            }}</el-button>
          </el-descriptions-item>
          <el-descriptions-item
            :label="$t('pages.equipment.text317')"
            v-if="info.fingerLockSn"
            >{{ info.fingerLockSn }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text119')"
            v-if="info.meterBleKey"
            >{{ info.meterBleKey }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text120')"
            v-if="info.meterBleMacAddress"
            >{{ info.meterBleMacAddress }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text121')"
            v-if="info.meterBleName"
            >{{ info.meterBleName }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text122')"
            v-if="info.meterFwVersion"
            >{{ info.meterFwVersion }}</el-descriptions-item
          ><el-descriptions-item
            :label="$t('pages.equipment.text123')"
            v-if="info.meterHwVersion"
            >{{ info.meterHwVersion }}</el-descriptions-item
          >
          <el-descriptions-item
            :label="$t('pages.equipment.text124')"
            v-if="info.meterSn"
            >{{ info.meterSn }}</el-descriptions-item
          >
          <el-descriptions-item 
            :label="$t('omission.text84')" 
            v-if="info.logisticsOrder">{{info.logisticsOrder}}
          </el-descriptions-item>
          <el-descriptions-item 
            :label="$t('omission.text85')" 
            v-if="info.saleNo">{{info.saleNo}}
          </el-descriptions-item>
          <el-descriptions-item 
            :label="$t('omission.text82')" 
            v-if="info.saleAgent&&info.saleAgent>0">{{info.saleAgent}}
          </el-descriptions-item>
          <el-descriptions-item 
            :label="$t('pages.equipment.text319')"
            v-if="info.motorSn">{{info.motorSn}}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="map">
      <div id="map"></div>
    </div>
    <FingerMacEdit
      :dialogVisible="dialogVisible"
      @fingerMacClose="fingerMacClose"
      @fingerMacChange="fingerMacChange"
      :fingerMac="fingerMac"
      :bikeCode="bikeCode"
    />
  </div>
</template>

<script>
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import DiluMap from "../../../../components/pubilc/dilu-map.vue";
import FingerMacEdit from "./fingerMacEdit.vue";
import cart from "../../../../assets/images/cart.png";
import { mapState } from "vuex";
import remoteLoad from "@/assets/js/remoteLoad.js";
export default {
  data() {
    return {
      dialogVisible: false,
      fingerMac: "",
      bikeCode: "",
    };
  },
  components: {
    DiluButton,
    DiluMap,
    FingerMacEdit,
  },
  computed: {
    ...mapState(["regionList", "currentRegion"]),
  },
  watch: {
    bikeInfo: {
      handler() {
        let regionList = this.regionList;
        if (regionList[this.currentRegion].id != "cn") {
          if (window.google) {
            this.initMap();
            // 未载入谷歌地图API，则先载入API再初始化
          } else {
            // 载入谷歌地图和UI组件
            Promise.all([
              remoteLoad(
                "https://maps.googleapis.com/maps/api/js?key=AIzaSyByfqxMers4lp-sXvkU4P8dX4i6yQ3RZ84&libraries=visualization,places,geometry&language=en-us&region=EG"
              ),
            ]).then(() => {
              this.initMap();
            });
          }
        } else {
          if (window.AMap && window.AMapUI) {
            this.initMap();
            // 未载入高德地图API，则先载入API再初始化
          } else {
            // 载入高德地图和UI组件
            Promise.all([
              remoteLoad(
                "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding"
              ),
            ]).then(() => {
              this.initMap();
            });
          }
        }
        // this.initMap();
      },
    },
  },
  props: ["info", "qrCode", "bikeInfo"],
  methods: {
    exportQrcode() {
      this.request
        .exportQrcode(this.qrCode, this.$t("pages.equipment.text128"))
        .then(() => {});
    },
    fingerMacEdit(e) {
      this.dialogVisible = true;
      this.fingerMac = this.info.fingerLockMacAddress;
      this.bikeCode = this.info.bikeCode;
    },
    fingerMacClose() {
      this.dialogVisible = false;
    },
    fingerMacChange(macNew) {
      this.dialogVisible = false;
      if (macNew!=this.info.fingerLockMacAddress) {
        this.request.updateFingerMac({bikeCode:this.info.bikeCode,fingerMac:macNew}).then((res) => {
          this.info.fingerLockMacAddress=macNew;
        });
      }
    },
    //高德地图
    initCnMap() {
      if (!this.bikeInfo.longitude && !this.bikeInfo.latitude) {
        return;
      }
      let center = [this.bikeInfo.longitude, this.bikeInfo.latitude];
      let that = this;
      var map = new AMap.Map("map", {
        mapStyle: "amap://styles/398469a1eaea0a930c1cb33226ee3080", //设置地图的显示样式
        center: center,
        zoom: 13,
        viewMode: "3D",
      });

      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder();
        geocoder.getAddress(center, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            let marker = new AMap.Marker({
              position: center,
              icon: cart,
              map: map,
            });
            map.setFitView(marker);
            // result为对应的地理位置详细信息
            var info = [];
            info.push("<div class='map-info'><div></div>");
            info.push(
              `<div style='padding:7px 0px 0px 0px;'><h4 class='map-title'><i class='el-icon-location-outline'></i>${result.regeocode.formattedAddress}</h4>`
            );
            if (that.bikeInfo.lastOnlineTime != null) {
              info.push(
                "<h5 class='map-time'>" + that.bikeInfo.lastOnlineTime + "</h5>"
              );
            }
            info.push(
              "<div class='map-li'>" +
                that.$t("pages.equipment.text129") +
                ": <span>" +
                that.bikeInfo.totalKilometers +
                "km</span></div>"
            );
            info.push(
              "<div class='map-li'>" +
                that.$t("pages.equipment.text133") +
                ": <span>" +
                that.bikeInfo.batteryPower +
                "%</span></div>"
            );
            let status =
              that.bikeInfo.status == 0
                ? that.$t("pages.equipment.text14")
                : that.$t("pages.equipment.text15"); //车辆状态 0缺电 1 正常
            info.push(
              "<div class='map-li'>" +
                that.$t("pages.equipment.text130") +
                ": <span>" +
                status +
                "</span></div>"
            );
            let netStatus =
              that.bikeInfo.netStatus == 0
                ? that.$t("pages.equipment.text17")
                : that.$t("pages.equipment.text18"); //通信状态 0在线 1离线
            info.push(
              "<div class='map-li'>" +
                that.$t("pages.equipment.text134") +
                ": <span>" +
                netStatus +
                "</span></div>"
            );
            let lockStatuStr =
              that.bikeInfo.lockStatus == 0
                ? that.$t("pages.equipment.text135")
                : that.$t("pages.equipment.text136");
            info.push(
              `<div class='map-li'>${that.$t(
                "pages.equipment.text137"
              )}: <span>${lockStatuStr}</span></div>`
            );
            let batteryLockStatusStr =
              that.bikeInfo.batteryLockStatus == 0
                ? that.$t("pages.equipment.text135")
                : that.$t("pages.equipment.text136");
            info.push(
              `<div class='map-li'>${that.$t(
                "pages.equipment.text138"
              )}: <span>${batteryLockStatusStr}</span></div>`
            );
            info.push("</div></div>");
            let infoWindow = new AMap.InfoWindow({
              offset: new AMap.Pixel(8, -30),
              content: info.join(""),
            });

            infoWindow.open(map, center);
          }
        });
      });
    },
    //谷歌地图
    initGoogleMap() {
      if (!this.bikeInfo.longitude && !this.bikeInfo.latitude) {
        return;
      }
      let that = this;
      let map = new google.maps.Map(document.getElementById("map"), {
        mapId: "1dac188ecae44d48",
        zoom: 15,
        center: new google.maps.LatLng({
          lat: Number(that.bikeInfo.latitude),
          lng: Number(that.bikeInfo.longitude),
        }),
        disableDefaultUI: true,
      });

      const geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({
          location: new google.maps.LatLng({
            lat: Number(that.bikeInfo.latitude),
            lng: Number(that.bikeInfo.longitude),
          }),
        })
        .then((response) => {
          if (response.results[0]) {
            var info = [];
            info.push("<div class='map-info'><div></div>");
            info.push(
              `<div style='padding:7px 0px 0px 0px;'><h4 class='map-title'><i class='el-icon-location-outline'></i>${response.results[1].formatted_address}</h4>`
            );
            info.push(
              "<h5 class='map-time'>" + that.bikeInfo.lastOnlineTime + "</h5>"
            );
            info.push(
              "<div class='map-li'>" +
                that.$t("pages.equipment.text129") +
                ": <span>" +
                that.bikeInfo.totalKilometers +
                "km</span></div>"
            );
            info.push(
              "<div class='map-li'>" +
                that.$t("pages.equipment.text133") +
                ": <span>" +
                that.bikeInfo.batteryPower +
                "%</span></div>"
            );
            let status =
              that.bikeInfo.status == 0
                ? that.$t("pages.equipment.text14")
                : that.$t("pages.equipment.text15"); //车辆状态 0缺电 1 正常
            info.push(
              "<div class='map-li'>" +
                that.$t("pages.equipment.text130") +
                ": <span>" +
                status +
                "</span></div>"
            );
            let netStatus =
              that.bikeInfo.netStatus == 0
                ? that.$t("pages.equipment.text17")
                : that.$t("pages.equipment.text18"); //通信状态 0在线 1离线
            info.push(
              "<div class='map-li'>" +
                that.$t("pages.equipment.text134") +
                ": <span>" +
                netStatus +
                "</span></div>"
            );
            let lockStatuStr =
              that.bikeInfo.lockStatus == 0
                ? that.$t("pages.equipment.text135")
                : that.$t("pages.equipment.text136");
            info.push(
              `<div class='map-li'>${that.$t(
                "pages.equipment.text137"
              )}: <span>${lockStatuStr}</span></div>`
            );
            let batteryLockStatusStr =
              that.bikeInfo.batteryLockStatus == 0
                ? that.$t("pages.equipment.text135")
                : that.$t("pages.equipment.text136");
            info.push(
              `<div class='map-li'>${that.$t(
                "pages.equipment.text138"
              )}: <span>${batteryLockStatusStr}</span></div>`
            );
            info.push("</div></div>");
            const infowindow = new google.maps.InfoWindow({
              content: info.join(""),
            });
            const marker = new google.maps.Marker({
              position: new google.maps.LatLng({
                lat: Number(that.bikeInfo.latitude),
                lng: Number(that.bikeInfo.longitude),
              }),
              icon: cart,
              map,
            });
            infowindow.open({
              anchor: marker,
              map,
              shouldFocus: false,
            });

            marker.addListener("click", () => {
              infowindow.open({
                anchor: marker,
                map,
                shouldFocus: false,
              });
            });
          } else {
            window.alert("No results found");
          }
        })
        .catch((e) => window.alert("Geocoder failed due to: " + e));
    },
    initMap() {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        this.initGoogleMap();
      } else {
        this.initCnMap();
      }
    },
  },
};
</script>

<style scoped>
.module-info {
  padding: 20px 10px;
  box-sizing: border-box;
}

.data-ul {
  margin-bottom: 20px;
}

.info-image {
  width: 260px;
  flex-shrink: 0;
  float: left;
  margin-right: 12px;
  margin-bottom: 10px;
}
.info-image img {
  width: 100%;
  display: block;
}
.info-list {
  display: flex;
  flex-direction: column;
  margin: 0 30px;
  flex: 1;
}
.info-list-title {
  margin-top: 84px;
  margin-left: 30px;
  display: flex;
  align-items: center;
}
.info-list-title span {
  font-size: 30px;
  font-family: DIN;
  font-weight: bold;
  line-height: 36px;
  color: #000000;
}
.info-list-title label {
  display: block;
  border: 1px solid #efa22b;
  border-radius: 15px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #efa22b;
  padding: 2px 10px;
  margin-left: 10px;
}
.describe {
  margin-left: 30px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 30px;
  color: #000000;
  margin-top: 20px;
  margin-bottom: 30px;
}
.qr-code {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  float: right;
  margin: 20px 20px 0 0;
}
.qr-code img {
  width: 99px;
  display: block;
  margin-bottom: 5px;
}
.map {
  width: 100%;
  height: 428px;
  background: #ffffff;
}
#map {
  width: 100%;
  height: 100%;
}
</style>